module.exports = __webpack_public_path__ + "img/civ.d939dcac.svg";